export default "__VITE_ASSET__BZvWvDvY__"